export enum FileType {
  Default = 0,
  Pod = 1
}